var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"data-grid-file-link-cell",attrs:{"href":_vm.fileLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.cellText || '点击下载'))])
}
var staticRenderFns = []

export { render, staticRenderFns }